import React from "react";
import { CollegeEnrollLogo, Facebook, Instagram } from "../icons/index";

const Footer = () => {
    const currentYear = new Date().getFullYear();
    return (
        <footer className="relative py-10 md:py-[54px] bg-secondary-500">
            
            <div className="md:flex justify-between max-w-[1320px] w-full px-[20px] mx-auto text-center md:text-left">
                <div className="flex flex-col items-center md:items-start shrink-0">
                    <a
                        href="https://collegenroll.com/"
                        target="_blank"
                        rel="noreferrer"
                        className="h-[33px]"
                        aria-label="CollegEnroll"
                    >
                        <CollegeEnrollLogo />
                    </a>
                    <p className="mt-3 md:mt-4 mb-4 md:mb-6 font-lexendlight text-[13px] leading-[17.55px] text-secondary-200 font-light">
                        Copyright © {currentYear} | Collegenroll
                    </p>

                    <div className="hidden md:flex justify-center items-center">
                        <a
                            href="https://www.facebook.com/collegenroll?mibextid=ZbWKwL%3F"
                            className="mr-4"
                            target="_blank"
                            rel="noreferrer"
                            aria-label="CollegEnroll Facebook"
                        >
                            <Facebook />
                        </a>
                        <a
                            href="https://www.instagram.com/collegenroll/?igshid=MzRlODBiNWFlZA%3D%3D%3F"
                            target="_blank"
                            rel="noreferrer"
                            aria-label="CollegEnroll Instagram"
                        >
                            <Instagram />
                        </a>
                    </div>
                </div>
                <div className="flex md:max-w-[664px] w-full flex-col md:ml-[30px]">
                    <ul className="flex flex-col md:flex-row justify-between items-center">
                        <li className="shrink-0 relative mr-0  leading-[38px] md:leading-none last:pr-0">
                            <a
                                href="https://collegenroll.com/preferences/"
                                className="font-lexendlight text-sm text-light-500 font-light"
                            >
                                Preferences
                            </a>
                        </li>
                        <li className="shrink-0 relative mr-0  leading-[38px] md:leading-none">
                            <a
                                href="https://collegenroll.com/about-us/"
                                className="font-lexendlight text-sm text-light-500 font-light"
                            >
                                About Us
                            </a>
                        </li>
                        <li className="shrink-0 relative mr-0  leading-[38px] md:leading-none">
                            <a
                                href="https://collegenroll.com/cookie-policy/"
                                className="font-lexendlight text-sm text-light-500 font-light"
                            >
                                Cookie Policy
                            </a>
                        </li>
                        <li className="shrink-0 relative mr-0  leading-[38px] md:leading-none">
                            <a
                                href="https://collegenroll.com/privacy-policy/"
                                className="font-lexendlight text-sm text-light-500 font-light"
                            >
                                Privacy Policy
                            </a>
                        </li>
                        <li className="shrink-0 relative mr-0  leading-[38px] md:leading-none">
                            <a
                                href="https://collegenroll.com/contact-us/"
                                className="font-lexendlight text-sm text-light-500 font-light"
                            >
                                Contact Us
                            </a>
                        </li>
                    </ul>
                    <div className="flex justify-center items-center md:hidden mt-5">
                        <a
                            href="https://www.facebook.com/collegenroll?mibextid=ZbWKwL%3F"
                            className="mr-4"
                            target="_blank"
                            rel="noreferrer"
                            aria-label="CollegEnroll Facebook"
                        >
                            <Facebook />
                        </a>
                        <a
                            href="https://www.instagram.com/collegenroll/?igshid=MzRlODBiNWFlZA%3D%3D%3F"
                            target="_blank"
                            rel="noreferrer"
                            aria-label="CollegEnroll Instagram"
                        >
                            <Instagram />
                        </a>
                    </div>
                    <p className="mt-6 font-lexendlight text-[13px] leading-normal text-secondary-200 font-light opacity-80">
                        <strong className="font-lexendSemibold font-semibold">Disclosure:</strong> We will collect your contact information to respond to your
                        requests and provide you with educational matching services. As a result, you may be matched to one or more sponsored schools
                        from which we receive compensation. Compensation may impact where Sponsored Schools appear on our websites. We use cookies and
                        other tracking technologies to collect your personal information in order to gauge online activity on our website. For more
                        information, see our{" "}
                        <a
                            href="https://collegenroll.com/privacy-policy/"
                            className="underline"
                        >
                            privacy policy.
                        </a>
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
